<template>
	<div class="password-form">
		<h2>{{ $t('base.profile.change_password') }}</h2>
		<success-box v-if="success" @close="reset">{{ success }}</success-box>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-password v-model="model.password_old" name="password_old" :placeholder="$t('labels.profile.old_password')" rules="required|min:8"/>
			<input-password v-model="model.password_new" name="password_new" :placeholder="$t('labels.profile.new_password')" rules="required|min:8"/>
			<input-password v-model="model.password_new_confirm" name="password_new_confirm" :placeholder="$t('labels.profile.confirm_new_password')" :rules="'required|confirmed:'+model.password_new"/>
			<error-box v-if="error" :error="error"/>
			<button-submit :loading="loading">{{ $t('buttons.actions.update_password') }}</button-submit>
		</form>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			success: null,
			error: null,
			loading: false,
			model: {
				password_old: '',
				password_new: '',
				password_new_confirm: ''
			}
		}
	},
	computed: {
		user () {
			return this.$store.getters.getUser
		}
	},
	methods: {
		reset () {
			this.success = null
			this.error = null
			this.loading = false
			this.model = {
				password_old: '',
				password_new: '',
				password_new_confirm: ''
			}
		},
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.updatePassword()
			})
		},
		updatePassword () {
			this.success = null
			this.error = null
			this.loading = true
			this.$api.users.password.edit(this, this.user_uid, this.model)
				.then(response => {
					this.$log.info('user profile', 'users.password.edit OK', response)()
					this.success = response.body.message
				})
				.catch(error => {
					this.$log.error('user profile', 'users.password.edit ERROR', error)()
					this.error = error
				})
				.finally(() => {
					this.loading = false
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/accountinformation/PasswordForm.vue